import http from '../../shared/http.js';
import { verlaufParentPfad } from '../../shared/verlaufParent.js';
import { withFlash } from '../../shared/flash.js';
import { bindFormModule } from '../../shared/formBinding.js';
import { formModalSaved, isFormModalOpen } from '../../shared/formModal.js';
import { hideLoading, notifyError, notifySuccess, showLoading } from '../../shared/notify.js';

// Turns the form into the JSON body the API expects.
function readForm(form) {
  const data = Object.fromEntries(new FormData(form).entries());

  // The empty option means "no contact". Sending '' would fail the isMongoId
  // check, so the key comes off entirely.
  if (!data.ansprechperson) delete data.ansprechperson;

  data.text = (data.text || '').trim();

  return data;
}

async function submit(form) {
  const submitButton = form.querySelector('button[type="submit"]');
  const { verlaufId } = form.dataset;
  // Whichever entity this note belongs to - see shared/verlaufParent.js.
  const parentPfad = verlaufParentPfad(form.dataset);
  const data = readForm(form);

  if (submitButton) submitButton.disabled = true;
  showLoading('Wird gespeichert …');

  try {
    // Editing goes to the entry's own route; creating goes to the parent's
    // nested one, since that is where the record it documents comes from.
    if (verlaufId) await http.patch(`/verlauf/${verlaufId}`, data);
    else await http.post(`/${parentPfad}/verlauf`, data);

    // In the dialog the timeline is on screen behind it, so closing and
    // refreshing shows the entry without a reload. On the standalone page there
    // is nothing to go back to, so it navigates and the flash key carries the
    // message across the load.
    if (isFormModalOpen()) {
      hideLoading();
      formModalSaved();
      notifySuccess(verlaufId ? 'Eintrag wurde aktualisiert.' : 'Notiz wurde erfasst.');
    } else {
      window.location.href = withFlash(
        `/${parentPfad}`,
        verlaufId ? 'verlauf-aktualisiert' : 'verlauf-erstellt'
      );
    }
  } catch (err) {
    hideLoading();
    if (submitButton) submitButton.disabled = false;
    notifyError(
      err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
    );
  }
}

export function initKundeVerlaufForm() {
  bindFormModule('verlauf-form', submit);
}
